import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { ROLE_LABELS } from "@/lib/api";
import Logo from "@/components/Logo";
import { House, Camera, AirplaneTilt, Receipt, User, SignOut } from "@phosphor-icons/react";

const TABS = [
  { to: "/", label: "Home", icon: House, end: true, testid: "tab-home" },
  { to: "/punch", label: "Punch", icon: Camera, testid: "tab-punch" },
  { to: "/my-leave", label: "Leave", icon: AirplaneTilt, testid: "tab-leave" },
  { to: "/my-payslips", label: "Salary", icon: Receipt, testid: "tab-salary" },
  { to: "/profile", label: "Profile", icon: User, testid: "tab-profile" },
];

export default function StaffLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  async function onLogout() {
    await logout();
    nav("/staff", { replace: true });
  }

  return (
    <div className="min-h-screen bg-[#0D0D10] text-white flex flex-col">
      <header className="flex items-center justify-between px-4 h-14 border-b border-[#2D2D35] sticky top-0 z-30 bg-[#0D0D10]">
        <Logo size="sm" />
        <div className="flex items-center gap-3">
          <div className="text-right hidden sm:block">
            <div className="text-sm font-medium leading-tight" data-testid="staff-name">{user?.name}</div>
            <div className="text-[10px] uppercase tracking-widest text-[#E50914]">{ROLE_LABELS[user?.role]}</div>
          </div>
          <button onClick={onLogout} data-testid="staff-logout"
                  className="p-2 text-zinc-400 hover:text-white">
            <SignOut size={18} weight="bold" />
          </button>
        </div>
      </header>

      <main className="flex-1 pb-24">
        <Outlet />
      </main>

      <nav className="fixed bottom-0 inset-x-0 border-t border-[#2D2D35] bg-[#0D0D10]/95 backdrop-blur z-40">
        <div className="grid grid-cols-5">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              data-testid={t.testid}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center py-2.5 text-[10px] uppercase tracking-widest transition-colors duration-200
                 ${isActive ? "text-[#E50914]" : "text-zinc-500 hover:text-white"}`
              }
            >
              <t.icon size={22} weight={({ isActive }) => isActive ? "fill" : "regular"} />
              <span className="mt-1">{t.label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
